import { useEffect, useState } from "react";
import { useMaintenanceMode } from "@/hooks/useMaintenanceMode";
import { useAuth } from "@/hooks/useAuth";
import MaintenancePage from "@/pages/MaintenancePage";

interface MaintenanceWrapperProps {
  children: React.ReactNode;
}

const MaintenanceWrapper = ({ children }: MaintenanceWrapperProps) => {
  const { isMaintenanceMode, loading: maintenanceLoading } = useMaintenanceMode();
  const { isAdmin, loading: authLoading } = useAuth();
  const [shouldShowMaintenance, setShouldShowMaintenance] = useState(false);

  useEffect(() => {
    // Wait for both auth and maintenance status to load
    if (authLoading || maintenanceLoading) {
      return;
    }

    // Show maintenance page only if:
    // 1. Maintenance mode is enabled
    // 2. User is not an admin
    setShouldShowMaintenance(isMaintenanceMode && !isAdmin);
  }, [isMaintenanceMode, isAdmin, authLoading, maintenanceLoading]);

  // Show loading state while checking auth and maintenance status
  if (authLoading || maintenanceLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (shouldShowMaintenance) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
};

export default MaintenanceWrapper;
